import { render, staticRenderFns } from "./HrIndex.vue?vue&type=template&id=2035ffae&"
import script from "./js/index.js?vue&type=script&lang=js&"
export * from "./js/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports